import { render } from "./location-search.vue?vue&type=template&id=6d5d8f21&ts=true"
import script from "./location-search.vue?vue&type=script&lang=ts"
export * from "./location-search.vue?vue&type=script&lang=ts"

import "./location-search.vue?vue&type=style&index=0&id=6d5d8f21&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__